import axios from 'axios';
import store from '../redux/store';

axios.interceptors.request.use(function (req) {
  let token = sessionStorage.getItem("token");
  if (token) {
    req.headers.token = token;
    let tenantName = sessionStorage.getItem("tenantName");
    if (tenantName && !req.headers.tenantname) {
      req.headers.tenantname = tenantName;
    }
  }
  return req;
});

axios.interceptors.response.use(function (res) {
  if (res.data.status === "error") {
    if (res.data.message === "Token is invalid." || res.data.message === "Can not find tenant admin account.") {
      $(".modal").modal("hide");
      sessionStorage.clear();
      store.dispatch({type: 'LOGOUT'});
    }
    $.bigBox({
      title : "Alert",
      content : res.data.message,
      color : "#C46A69",
      icon : "fa fa-warning shake animated",
      timeout : 6000
    });
    return Promise.reject(res.data);
  }
  return res.data;
}, err => {
  if (err.response && err.response.status === 401) {
    sessionStorage.clear();
    store.dispatch({type: 'LOGOUT'});
  } else if (err.response && err.response.status === 403) {
    $.bigBox({
      title : "Access Denied",
      content : "You do not have permission to access this tenant or operation.",
      color : "#C46A69",
      icon : "fa fa-warning shake animated",
      timeout : 6000
    });
  } else {
    if (err.config && err.config.url && err.config.url.indexOf("/maintenance.json") < 0) {
      $.bigBox({
        title : "Alert",
        content : "Internal Server Error!",
        color : "#C46A69",
        icon : "fa fa-warning shake animated",
        timeout : 6000
      });
    }
  }
  return Promise.reject(err);
});



// WEBPACK FOOTER //
// ./src/utils/axios.js